const getClassName = {
  computed: {
    getClassName() {
      return className => {
        return [className, this.media ? className + '--sp' : null];
      };
    },
    getClassNameActive() {
      return (className, data, value) => [
        ...this.getClassName(className),
        data.id === value ? className + '--active' : null,
      ];
    },
  },
};

export default getClassName;
